<div class="pl-2 col-12 col-md-8">
  <project-record  (onSavedData)="onSaveProperty($event)" (onClose)="onclose()" >  </project-record>
</div>

